export default "__VITE_ASSET__DgfUQID___"